<template>
  <ul class="roomFeaturesBadge">
    <li class="roomFeaturesBadge__rhg-badge" v-if="room.size">
      {{ translate('rdSize') }}: {{ room.size | spaceInSize }}
    </li>
    <li class="roomFeaturesBadge__rhg-badge">
      {{ translate('rdMaxGuests') }}:
      {{ translate('boNumAdults', room.occupancy.adults, room.occupancy.adults) }}
      <span v-if="room.occupancy.children > 0"
        >,
        {{
          translate('boNumChildren', room.occupancy.children, room.occupancy.children)
        }}&nbsp;</span
      >
    </li>
    <li class="roomFeaturesBadge__rhg-badge" v-if="room.bedType">
      {{ translate('rdBedType') }}: {{ translatedBedType }}
    </li>
    <li class="roomFeaturesBadge__rhg-badge" v-if="room.isAccessible()">
      {{ translate('rdAccessibleFeatureAvailable') }}
    </li>
  </ul>
</template>

<script>
import Room from '../../domain/Room'

export default {
  name: 'RoomFeaturesBadge',
  props: {
    room: {
      type: Room
    }
  },
  filters: {
    spaceInSize(size) {
      const onlyNumbers = /(\d+)/
      return size.replace(onlyNumbers, '$1 ')
    }
  },
  computed: {
    translatedBedType() {
      let bedType = this.room.bedType
      if (bedType.includes(' and ')) {
        bedType = bedType.replaceAll(' and ', ` ${this.translate('weAnd')} `)
      }
      if (bedType.includes(' or ')) {
        bedType = bedType.replaceAll(' or ', ` ${this.translate('weOr')} `)
      }
      return bedType
    }
  }
}
</script>

<style lang="scss" scoped>
i.roomFeaturesBadge__feature-icon {
  margin-right: 1rem;
}
.roomFeaturesBadge {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;

  @media (min-width: 992px) {
    margin-bottom: 6px;
  }

  .rhg-badge {
    margin: 6px 8px 6px 0;
  }

  &__rhg-badge {
    padding: 4px 8px;
    font-size: 12px;
    margin: 6px 8px 6px 0;
    background-color: rgb(238, 238, 239);
    border-radius: 35px;
  }
}
</style>
